import React, { useState, useEffect } from 'react';
import { Stack, Typography } from '@mui/material';
import CalendarDateField from './CalendarDateField';
import CalendarTimeField from './CalendarTimeField';
export default function CalendarDateTimeField({ value = '', onChange, calendar, clock, label, timezone, onValidityChange }) {
  const [dateValid, setDateValid] = useState(true);
  const [date = '', time = ''] = value.split('T');
  useEffect(() => { onValidityChange?.(dateValid && /^\d{4}-\d{2}-\d{2}$/.test(date) && /^([01]\d|2[0-3]):[0-5]\d$/.test(time)); }, [dateValid, date, time, onValidityChange]);
  return <Stack spacing={2}>
    <CalendarDateField label={`${label} date`} value={date} onChange={next => onChange(`${next}T${time}`)} calendar={calendar} onValidityChange={setDateValid} />
    <CalendarTimeField label={`${label} time`} value={time} onChange={next => onChange(`${date}T${next}`)} clock={clock} />
    <Typography variant="caption">Timezone: {timezone}</Typography>
  </Stack>;
}
